import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > 700);
    on();
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="back-to-top"
      aria-label="Back to top"
      className={`fixed z-40 bottom-8 right-6 md:right-10 w-12 h-12 grid place-items-center bg-ink-900 text-gold border border-gold/40 hover:bg-gold hover:text-ink-900 transition-all duration-300 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 pointer-events-none translate-y-3'}`}
    >
      <ArrowUp className="w-4 h-4" />
    </button>
  );
};

export default BackToTop;
